import { displayValues } from '@/metrics/constants'

export const displayOptions = [
  { key: displayValues.daily, label: 'D', tooltipKey: 'day' },
  { key: displayValues.weekly, label: 'W', tooltipKey: 'week' },
  { key: displayValues.monthly, label: 'M', tooltipKey: 'month' },
  { key: displayValues.quarterly, label: 'Q', tooltipKey: 'quarter' },
]
